const NutrientLoading = () => {
  const NutrientLoadingData = [
    {
      Source: 'Inflows',
      'Phosphorus Mass (pounds)': '',
      'Nitrogen Mass (pounds)': '',
      _isSubHeading: true,
    },
    {
      Source: 'Cherry Creek (CC-10)',
      'Phosphorus Mass (pounds)': Number(4673).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(36138).toLocaleString(),
    },
    {
      Source: 'Cottonwood Creek (CT-2)',
      'Phosphorus Mass (pounds)': Number(844).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(28865).toLocaleString(),
    },
    {
      Source: 'Precipitation',
      'Phosphorus Mass (pounds)': Number(242).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(4786).toLocaleString(),
    },
    {
      Source: 'Alluvial Groundwater',
      'Phosphorus Mass (pounds)': Number(1520).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(5438).toLocaleString(),
    },
    {
      Source: 'Total Inflows',
      'Phosphorus Mass (pounds)': Number(7280).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(75226).toLocaleString(),
      _isTotal: true,
    },
    {
      Source: 'Outflows',
      'Phosphorus Mass (pounds)': '',
      'Nitrogen Mass (pounds)': '',
      _isSubHeading: true,
    },
    {
      Source: 'Evaporation',
      'Phosphorus Mass (pounds)': Number(0).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(0).toLocaleString(),
    },
    {
      Source: 'Reservoir releases',
      'Phosphorus Mass (pounds)': Number(-4101).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(-43224).toLocaleString(),
    },
    {
      Source: 'Total Outflows',
      'Phosphorus Mass (pounds)': Number(-4101).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(-43224).toLocaleString(),
      _isTotal: true,
    },
    {
      Source: 'WY 2021 Change in Storage',
      'Phosphorus Mass (pounds)': Number(3177).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(32002).toLocaleString(),
      _isSubHeading: true,
    },
  ];

  // Declare and configure request overview table
  const NutrientLoadingTable = new requestTable({
    container: '#nutrient-loading-table',
    filterEnabled: false,
    tableHeaders: {
      Source: 'Source',
      'Phosphorus Mass (pounds)': 'Phosphorus Mass (pounds)',
      'Nitrogen Mass (pounds)': 'Nitrogen Mass (pounds)',
    },
    tableActions: [],
    tableData: NutrientLoadingData,
  });
  NutrientLoadingTable.buildTable();
};

// Build pie chart
const NutrientBalance = () => {
  const InflowProportions = new Pie({
    container: '#inflow-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    color: d3.scaleOrdinal(['rgb(2, 117, 216)', 'rgb(255,140,0)', 'rgb(92, 184, 92)', 'rgb(128,128,128)']),
    resultField: 'rvalue',
    categoryField: 'source',
    data: [
      { source: 'Cherry Creek', rvalue: 62 },
      { source: 'Cottonwood Creek', rvalue: 25 },
      { source: 'Alluvial Groundwater', rvalue: 3 },
      { source: 'Precipitation', rvalue: 9 },
    ],
  }).draw();
};
